"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LicenseForm = _interopRequireDefault(require("./LicenseForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FormItem = _form.default.Item;
// const Option = Select.Option;

var AddLicenseModal = function AddLicenseModal(_ref) {
  var onSubmit = _ref.onSubmit,
    states = _ref.states,
    _ref$form = _ref.form,
    validateFields = _ref$form.validateFields,
    getFieldDecorator = _ref$form.getFieldDecorator,
    resetFields = _ref$form.resetFields;
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    validateFields(function (err, values) {
      if (err) {
        return;
      }
      onSubmit(values);
      resetFields();
    });
  };
  return /*#__PURE__*/_react.default.createElement(_form.default, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_LicenseForm.default, {
    states: states,
    getFieldDecorator: getFieldDecorator
  }), /*#__PURE__*/_react.default.createElement(FormItem, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: 'primary',
    htmlType: "submit"
  }, "Add")));
};
AddLicenseModal.propTypes = {
  states: _propTypes.default.array
};
var _default = _form.default.create({
  name: 'AddLicenseModal'
})(AddLicenseModal);
exports.default = _default;